<template>
    <div class="search-fellow-box">
        <div class="search-input-box flexBox">
            <div class="search-box">
                <input type="search" class="search-input" ref="searchinput" v-model="keywords" maxlength="50" placeholder="输入车主全名/昵称/手机" spellcheck="false" @keyup.enter="getSearch" @focus="searchFocus" @blur="SearchBlur">
            </div>
            <!-- <input type="search" class="search-input" ref="searchinput" v-model="keywords" maxlength="50" placeholder="输入车主全名/昵称/手机" spellcheck="false" @keyup.enter="Searching"> -->
            <!-- <input type="search" class="search-input" ref="searchinput" v-model="keywords" maxlength="50" placeholder="输入车主全名/昵称/手机" spellcheck="false" @keyup.enter="keyEnterSearch"> -->
            <i class="icon icon-searchClose search-close" v-show="keywords" @click="ClearSearch">
                <span class="path1"></span><span class="path2"></span>
            </i>
            <span class='search-btn' :class="{'search-btn-disabled':!keywords}" v-show='isSearch' @click="getSearch">搜索</span>
        </div>

        <div class="search-fellow-tip padding-sets" v-show="!actionSearch">
            <p class="tip-head">提示</p>
            <span class="tip-content">可以通过输入车主的全名来精确查找该车主Fellow</span>
        </div>
        <div class="search_fellow_img padding-sets" v-show="!actionSearch">
            <img src="/static/images/fellowImg.png" @click="goOrderData">
            <div class='search_fellow_img_title' @click="goOrderData">
                <div class="img_title">
                    <span>车主订单数据一站式查询</span>
                </div>
                <div class="order_next">(正在规划敬请期待)</div>
            </div>
        </div>

        <template v-if="fellowResult">
            <section class="search-fellow-list padding-sets" v-for="result in fellowResult">
                <div class="consumer-container flexBox">
                    <img class="consumer-avator" :src="result.custom.avator" @error="$imgErr">
                    <div class="consumer-info flexItem">
                        <p class="base-info">
                            <span class="name" v-text="result.custom.name"></span>
                            <span class="nickname" v-text="'(' + result.custom.nickName + ')'" v-if="result.custom.nickName"></span>
                        </p>
                        <p class="car-info">
                            <span class="cartype" :class="{'cartype-border':result.custom.carType}" v-text="result.custom.carType"></span>
                        </p>
                        <p class="other-info">
                            <span class="telephone" v-text="result.custom.telephone"></span>
                            <span class="workplace" v-text="result.custom.workPlace"></span>
                        </p>
                    </div>
                </div>
                <div class="fellow-container">
                    <h3>Ta的专属Fellow</h3>
                    <span class="fellow-tel-wrap flexBox" @click="callPhone(result.fellow.telephone)">
                        <img class="fellow-avator" :src="result.fellow.avator" @error="$imgErr">
                        <div class="fellow-info flexItem">
                            <p class="account" v-text="result.fellow.name"></p>
                            <p class="location" v-text="result.fellow.workPlace"></p>
                        </div>
                        <div class="fellow-tel">
                            <img class="tel" src="/static/images/tel.png">
                        </div>
                    </span>
                </div>
            </section>
        </template>

        <div class="search-noresult-tip" v-show="unSatisfyTip">
            <div class="noresult flexBox">
                <i class="icon icon-noInfo"></i>
                <p class="fellow-noresult-text">未找到搜索结果</p>
                <p class="fellow-noresult-text">必须输入完整信息才能查询出结果</p>
            </div>
        </div>

        <!-- <nio-toast :showing="toastShow" :text="tipText"></nio-toast> -->
        <nio-toast :showing="toastShow" v-if="toastShow" :text="tipText"></nio-toast>

    </div>
</template>

<script>
    import nioToast from '@/components/toast'
    import { SEARCH } from '@/api'
    import dsBridge from '@/utils/jsbridge'

    export default {
        data () {
            return {
                keywords: '',
                fellowResult: [],
                actionSearch: false,
                unSatisfyTip: false,
                toastShow: false,
                tipText: '请再给多点信息吧<span>&emsp;</span>）：',
                isSearch:true,//是否点击搜索
                isWxWechat:false,//是否是微信环境
            }
        },
        mounted () {
            // this.$refs.searchinput.focus()
            this.GetFocus();
            
            if(dsBridge.call("toolkit.getTokenSyn")){
                this.isWxWechat=false;
            }else{
                 this.isWxWechat=true;
            }
           
        },
        methods: {
            // 打电话
            callPhone(data){
                if (this.authType === 'WECHAT') {
                window.location.href = "tel:" + data;
                } else if (this.authType === 'TOOLKIT') {
                    if (dsBridge.call("toolkit.getTokenSyn")) {
                        let phone = "toolkit://dial?phone=" + data;
                        dsBridge.call("common.dialSyn", phone);
                    }
                } else if(this.authType === 'APOLLO') {
                    dsBridge.call("ApolloApp.invokeAsyn",
                        {
                            "methodName": "callMobile",
                            "params":{
                                "tel":data
                        }
                    })
                }
            },
            searchFocus(){
                this.isSearch=true;
            },
            SearchBlur(){
                this.isSearch=false;
            },
            //获取光标时
            GetFocus(){
                this.isSearch=true;
                this.$refs.searchinput.focus()
            },
            //点击搜索
            getSearch(){
                if(this.keywords){
                    // this.isSearch=false;
                    this.Searching();
                }else{
                    this.isSearch=true;
                }       

            },
            //点击搜索
            keyEnterSearch(){
                // this.$refs.searchinput.blur();
            },
             //显示提示
            tipShow(tipText) {
                this.toastShow = true;
                this.tipText = tipText;
                let timer = setTimeout(() => {
                    this.toastShow = false;
                    clearTimeout(timer);
                }, 2500)
            },
            Searching () {
                this.keywords=this.keywords.trim();
                if (!this.keywords.replace(/^\s+|\s+$/g, '') || (this.keywords.length <= 1) && !/[\u4E00-\u9FA5]/.test(this.keywords)) {
                    this.toastShow = true
                    let timer = setTimeout( () => {
                        this.toastShow = false
                        clearTimeout(timer)
                    }, 1500)
                    return
                }

                this.actionSearch = true
                this.$refs.searchinput.blur()

                SEARCH.SearchFellow({
                    Keywords: this.keywords.trim()
                }).then( (res) => {
                    if(res.Code==200){
                        this.fellowResult = res.Data.List
                        if (res.Data.List && res.Data.List.length) {
                            this.unSatisfyTip = false
                        } else this.unSatisfyTip = true
                    }else{
                        this.tipShow(res.Msg||"请求失败")

                    }
                    
                }).catch((error)=>{
                     this.tipShow(error||"请求失败")
                })
            },
            ClearSearch () {
                this.isSearch=true;
                this.keywords = ''
                this.$refs.searchinput.focus()
                this.fellowResult = []
                this.actionSearch = false
                this.unSatisfyTip = false
            },
            feedback () {
                sessionStorage.nio_question = this.keywords || (sessionStorage.nio_question ? sessionStorage.nio_question : '')
                localStorage.feedback_cbRouter = this.$route.name
                this.$router.push({name: 'feedback', params: {from: this.$route.name}})
            },
            //点击订单数据一站式查询
            goOrderData(){
                this.$router.push({name:'orderData'});
            }
        },
        watch: {
            keywords (newV) {
                if (newV === '') this.ClearSearch()
            }
        },
        computed: {
            authType() {
                return localStorage.AUTH_TYPE
            }
        },
        components: {
            nioToast
        }
    }
</script>

<style lang="scss" scoped>
    .search-fellow-box {
        min-height: 100vh;
        padding-bottom: j(100);
    }
    .search-input-box {
        margin: 0 j(50);
        height: j(120);
        font-size: j(24);
        font-weight: 700;
        position: relative;
        display: flex;
        border-bottom: 1px solid #cdced4;
        // &:after {
        //     @include thin-bb (#cdced4);
        // }
        input, input::-webkit-input-placeholder {
            // font-size: j(48);
            font-size: j(44);
            font-weight: 700;
            color: #cdced4;
            caret-color: #00bebe;
        }
        input {
            // margin-right: j(32);
            color: #363c54;
            width: 100%;
            width:j(480);
            height:100%;
            // flex:1;
        }
        .search-box{
            flex:1;
            // border:1px solid red;
            margin-right: j(36);
        }
        .search-close {
            font-size: j(32);
        }
        .search-btn{
            height:100%;
            font-size:j(32);
            color:#00BEBE;
            display: flex;
            align-items: center;
            margin-left:j(20);
            background:#fff;
            
        }
        .search-btn-disabled{
           color:#CDCED4; 
        }
    }
    .search-fellow-tip {
        margin-top: j(60);
        .tip-head {
            margin-bottom: j(17);
            font-size: j(32);
            font-weight: bold;
            color: #040b29;
        }
        .tip-content {
            font-size: j(28);
            color: #9b9da9;
        }
    }
    .search-fellow-list {
        margin-top: j(40);
        .consumer-container {
            padding-left: j(30);
            .consumer-avator {
                width: j(120);
                height: j(120);
                margin-right: j(30);
                border-radius: 50%;
            }
            .base-info {
                font-size: j(30);
                color: #363C54;
                width: j(460);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .car-info {
                margin: j(10) 0;
                font-size: j(24);
                .cartype {
                    color: #9B9DA9;
                    padding: j(2) j(6);
                    // border: 1px solid #bcbcbc;
                    border-radius: j(4);
                }
                .cartype-border{
                    border: 1px solid #bcbcbc;
                }
            }
            .other-info {
                font-size: j(24);
                 color: #9B9DA9;
                .workplace {
                    margin-left: j(30);
                }
            }
        }
        .fellow-container {
            position: relative;
            z-index: 99;
            margin: j(40) 0 j(50);
            padding: j(30);
            border: 1px solid #f0f0f0;
            background: #fafafa;
            border-radius: j(4);
            &:before {
                width: 0;
                height: 0;
                position: absolute;
                top: j(-15);
                left: j(78);
                z-index: 12;
                content: '';
                border-bottom: j(16) solid #fafafa;
                border-left: j(16) solid transparent;
                border-right: j(16) solid transparent;
            }
            &:after {
                width: 0;
                height: 0;
                position: absolute;
                content: '';
                top: j(-17);
                left: j(76);
                z-index: 10;
                border-bottom: j(17) solid #f0f0f0;
                border-left: j(18) solid transparent;
                border-right: j(18) solid transparent;
            }
            h3 {
                font-weight: normal;
                font-size: j(24);
                 color: #9B9DA9;
                margin-bottom: j(30);
            }
            .fellow-avator {
                width: j(114);
                height: j(114);
                border-radius: 50%;
                margin-right: j(24);
            }
            .account {
                color: #363C54;
            }
            .location {
                margin-top: j(10);
                 color: #9B9DA9;
                font-size: j(24);
            }
            .fellow-tel {
                font-size: j(60);
                margin-top: j(24);
                .tel {
                    width: j(60);
                    height: j(60);
                }
            }
        }
    }
    .search-fellow-list + .search-fellow-list {
        padding-top: j(40);
        border-top: j(20) solid #f0f1f2;
    }
    .search-noresult-tip {
        margin-top: j(30);
        .noresult {
            height: 100%;
            flex-direction: column;
            justify-content: center;
            .icon {
                font-size: j(150);
                margin-top: j(200);
                margin-bottom: j(60);
            }
            .noresult-text {
                color: #9B9DA9;
                margin-top: 3px;
            }
        }
    }

    .padding-sets {
        padding: 0 j(50);
    }
    .search_fellow_img {
        width: 100%;
        margin: j(50) auto;
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        img {
            width: 100%;
            display: block;
        }
        .search_fellow_img_title {
            padding-right: j(50);
            position: absolute;
            left: j(50);
            right: j(50);
            div {
                text-align: right;
                font-size: j(28);
                display: block;
                color: #696D7F;
            }
            .img_title {
                font-size: j(28);
                color: #00BCBC;
            }
            .order_next {
                 font-size: j(20);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/search/searchFellow.vue